import { Component } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc'
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login-callback',
  standalone: true,
  imports: [],
  templateUrl: './login-callback.component.html',
  styleUrl: './login-callback.component.scss'
})
export class LoginCallbackComponent {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit() {
    let self = this;
    this.authService.retrieveToken().then(function () {
      self.redirect();
    });
  }

  /*
  * Redirect to session page
  */
  redirect () {
    this.router.navigate(['']);
  }
}